module.exports = __webpack_public_path__ + "static/TFR-by-Numbers-v2-aa01f8805344eed77d18fc620856fef3.jpg";